import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";
import { TourProvider } from "@reactour/tour";
import { RiCloseLine } from "react-icons/ri";

const root = ReactDOM.createRoot(document.getElementById("root"));
const steps = [
  {
    selector: ".step-1",
    content: {
      title: "Welcome to workplace insights",
      link: "Click on Workforce Insights",
      description:
        "to explore key team metrics through clear, interactive charts. Get valuable insights to drive better decisions.",
    },
  },
  {
    selector: ".step-2",
    content: {
      title: "Explore workforce insights  ",
      description:
        "On this page, you'll find interactive charts that provide a clear view of your team's performance, well-being, and key trends. Use them     to track metrics and identify areas that need your attention.",
    },
  },
  {
    selector: ".step-3",
    content: {
      title: "Recommendation button        ",
      description:
        "Click the lightbulb icon to receive AI-powered recommendations based on the data displayed in the chart. It helps you identify key areas to focus on for improvement.  ",
    },
  },
  {
    selector: ".step-4",
    content: {
      title: "Comparison button",
      description:
        "Click the comparison icon to see how this chart looks over different time periods. This helps you spot trends and track changes over time.   ",
    },
  },
];
const ContentComponent = (props) => {
  const content = props.steps[props.currentStep].content;
  const isFirstStep = props.currentStep === 0;
  const isLastStep = props.currentStep === props.steps.length - 1;
  return (
    <div className="card rounded-4">
      <div className="card-body text-center">
        <div className="d-flex justify-content-between align-items-center">
          <div className="h4 fw-semibold mb-0 w-100">{content.title}</div>
          <button
            className="bg-transparent border-0"
            onClick={() => props.setIsOpen(false)}
          >
            <RiCloseLine className="h4 mb-0" />
          </button>
        </div>
        <p className="my-3">
          {content.link && <span className="text-primary">{content.link}</span>}{" "}
          {content.description}
        </p>
        <button
          className="bg-transparent text-primary border-0"
          onClick={() => {
            if (isLastStep) {
              props.setCurrentStep(0);
            } else {
              props.setCurrentStep((s) => s + 1);
            }
          }}
        >
          {isFirstStep ? "Let's get started!" : "Next"}
        </button>
      </div>
    </div>
  );
};

root.render(
  <React.StrictMode>
    <HelmetProvider>
    <TourProvider
      styles={{
        popover: (base) => ({
          ...base,
          padding: 0,
          maxWidth: "450px",
          left: "16px",
          backgroundColor: "transparent",
        }),
        maskRect: (base) => ({
          ...base,
          border: "1px solid red",
        }),
        maskArea: (base) => ({
          ...base,
          rx: "8px",
        }),
      }}
      ContentComponent={ContentComponent}
      steps={steps}
      padding={{ mask: 0 }}
    >
      <App />
    </TourProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
